import { useCallback, useState } from 'react'

export const useScrollToNew = () => {
  const [newItemKey, setNewItemKey] = useState(null)

  const scrollRef = useCallback((node) => {
    if (node) {
      requestAnimationFrame(() => {
        node.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        setNewItemKey(null)
      })
    }
  }, [])

  const scrollRefFor = (key) => (newItemKey === key ? scrollRef : null)

  return { setNewItemKey, scrollRefFor }
}
